<section class="content-header">
  <a (click)="goBack()" class="previous cur">&#171; {{traductionsKeysEnum.BACK_TO_SCHEDULE| translate}}</a>
  <div class="container-fluid">
    <div class="row mb-2">
      <h2>{{traductionsKeysEnum.DETAIL_SCREEN| translate}}
        <span style="font-size: medium">

         <img style="width: 40px;height: 40px;margin-right: 11px;margin-left: 4px;"  src="{{image}}">
          {{dateFormat | date:'d MMMM yyyy ' : '': 'fr-FR'}} <i class="fa fa-calendar" aria-hidden="true"> {{traductionsKeysEnum.TO| translate}} </i>  {{dateFormat | date:'HH:mm ' : '': 'fr-FR'}}
          <span style="font-size: small" >({{dateFormat | date: 'yyyy-MM-dd'}} - {{id}}) </span> <span style="font-size: 15px;"> <b>{{traductionsKeysEnum.DURATION| translate}}  {{time}}s </b></span>
          <!--   <img  style="width: 25px;height: 27px;" src="{{}}">-->
        </span></h2>
    </div>
    <br/>
    <table class="table table-striped table-bordered table-sm row-border hover" datatable [dtOptions]="dtOptions">
      <caption>{{traductionsKeysEnum.ITEMS| translate}}</caption>
      <thead>
      <tr>
        <th>{{traductionsKeysEnum.ID_SEQUENCE| translate}}</th>
        <th>{{traductionsKeysEnum.RANK| translate}}</th>
        <th>{{traductionsKeysEnum.DURATION| translate}}</th>
        <th [width]="90">{{traductionsKeysEnum.INTERMEDIATE| translate}}</th>
        <th [width]="90">{{traductionsKeysEnum.CUSTOMER| translate}}</th>
        <th>{{traductionsKeysEnum.ITEM_COMMAND| translate}}</th>
        <th>{{traductionsKeysEnum.SPOT| translate}}</th>
        <th>{{traductionsKeysEnum.STATUT| translate}}</th>
        <th>{{traductionsKeysEnum.STATUT_DATE| translate}}</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      </tbody>
    </table>

  </div>
</section>
